import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import '@babel/polyfill'

import VueGtag from "vue-gtag";
// https://matteo-gabriele.gitbook.io/vue-gtag/
// https://analytics.google.com/analytics/web/#/p243392371/reports/home?params=_u..nav%3Dga1-experimental
Vue.use(
  VueGtag, {
  config: { 
    id: "G-C08TZXMH8J"
  }
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
